<template>
  <div class="home clearfix">
    <game-header></game-header>
    <router-view name="home"/>
    <betslip-box></betslip-box>
  </div>
</template>

<script>
// @ is an alias to /src
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from 'vuex';
import BetslipBox from '@/components/BetslipBox';
import GameHeader from '@/components/GameHeader';
import gateway from '../services/gateway';
import gameConfig from '@/config/gameConfig';

export default {
  name: 'home',
  components: {
    BetslipBox,
    GameHeader,
  },
  computed: {
    ...mapGetters([
      'gameId',
      'translations',
      'ticketPreviewShow',
    ]),
  },
  methods: {
    shortcutTranslations(shortcuts) {
      const tempShortcuts = cloneDeep(shortcuts);

      Object.keys(tempShortcuts).forEach((i) => {
        tempShortcuts[i].name = this.translations[tempShortcuts[i].name];
      });
      return tempShortcuts;
    },
  },
  mounted() {
    gateway.sendMessage('Product.UpdateSettings', {
      shortcuts: this.shortcutTranslations(gameConfig[this.gameId].shortcuts),
      ticketConfig: {
        color: gameConfig[this.gameId].color,
        icon: gameConfig[this.gameId].icon,
      },
    });
    if (!this.ticketPreviewShow) {
      gateway.sendMessage('Widget.UpdateSettings', {
        gamesHelp: {
          show: true,
        },
        calculator: {
          show: true,
        },
        ticketSession: {
          show: true,
        },
        ticketList: {
          show: true,
        },
      });
    }
  },
};
</script>
